__turbopack_context__.v({
  "badge": "ConditionalShift-module__gfwOvW__badge",
  "body": "ConditionalShift-module__gfwOvW__body",
  "chev": "ConditionalShift-module__gfwOvW__chev",
  "container": "ConditionalShift-module__gfwOvW__container",
  "intro": "ConditionalShift-module__gfwOvW__intro",
  "label": "ConditionalShift-module__gfwOvW__label",
  "list": "ConditionalShift-module__gfwOvW__list",
  "preview": "ConditionalShift-module__gfwOvW__preview",
  "routeHint": "ConditionalShift-module__gfwOvW__routeHint",
  "section": "ConditionalShift-module__gfwOvW__section",
  "sectionName": "ConditionalShift-module__gfwOvW__sectionName",
  "spinner": "ConditionalShift-module__gfwOvW__spinner",
  "summary": "ConditionalShift-module__gfwOvW__summary",
  "toggle": "ConditionalShift-module__gfwOvW__toggle",
  "toggleSelected": "ConditionalShift-module__gfwOvW__toggleSelected",
  "toolbar": "ConditionalShift-module__gfwOvW__toolbar",
});
